export interface ActorFields {
    actorType: string | null;
    actorId: string | null;
    actorName: string | null;
}

export const formatHistoryActor = ({ actorType, actorId, actorName }: ActorFields): string | null => {
    if (actorName) return actorName;
    if (actorType === 'system') return 'System';
    if (!actorId) return null;

    return actorType ? `${actorType}: ${actorId}` : actorId;
};
